import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { map, catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map'
import { environment } from '../../environments/environment';
import { UtilService } from '../shared/_services/util.service';
import { dateFormatPipe } from '../shared/_pipes/datePipe.pipe';



@Injectable()
export class AuthService {
  encode: any;
  BASE_URL;

  constructor(
    private http:HttpClient,
    private router:Router,
    private utilService: UtilService
  ) {
    this.BASE_URL = this.getBaseURL();
   }

  getBaseURL(){
    let baseURL:string = window.location.origin;
     return baseURL+"/api/";
      //return baseURL+":8080/";
  }


  //login API call
  login(user): Observable<any> {
    
    let params = new HttpParams();
    params = params.append('username',user.email);
    params = params.append('password', user.password);  
    //console.log(params);
    return this.http.post(`${this.BASE_URL}login`, params )
    .catch(this.utilService.handleError);
  }
    //for getting Customer report Data
    getCustomerReportsApi(pageNumber, pageSize){
      return this.http.get(`${this.BASE_URL}customer/report?pageNumber=`+pageNumber + `&pageSize=`+pageSize)
      .catch(this.handleError);
    }
    //for getting Sales Invoice Data
    getSalesInvoiceApi(pageNumber, pageSize){
      return this.http.get(`${this.BASE_URL}salesinvoice/report?pageNumber=`+pageNumber + `&pageSize=`+pageSize)
      .catch(this.handleError);
    }

    //login API call
    loginWithSession(token): Observable<any> {
      return this.http.get(`${this.BASE_URL}validatesession?sessionId=${token}`)
      .catch(this.utilService.handleError);
    }

  
  //forgot password api call
  forgotPwdAPi(userEmail){
    return this.http.get(`${this.BASE_URL}forgotPwd?username=`+encodeURIComponent(userEmail.email))
    // // .map(res => res.json())
    // .catch(this.utilService.handleError);
    .catch(this.utilService.handleError);
  }
  
  //registration api call
  registrationAPi(registrationData){
    return this.http.post(`${this.BASE_URL}registration`, registrationData )
    .catch(this.utilService.handleError);
  }

  //change password api
  changePwdApi(changePwdObj){
    // return this.http.get(`${this.BASE_URL}changePwd?oldPwd=`+changePwdObj.oldPwd+`&newPwd=`+changePwdObj.newPwd)
    // .catch(this.utilService.handleError);

    return this.http.post(`${this.BASE_URL}changePwd`, changePwdObj )
    .catch(this.utilService.handleError);

  }

  //for getting all users for user management page
  getAllUsersApi(){
    return this.http.get(`${this.BASE_URL}user/getUsers`)
    .catch(this.handleError);
  }

    //for getting user Data
    getUserDataApi(id){
      return this.http.get(`${this.BASE_URL}user/getUser?userId=`+id)
      .catch(this.handleError);
    }

  //create user api
  createUserApi(postData){
    return this.http.post(`${this.BASE_URL}createUser`, postData )
    .catch(this.utilService.handleError);
  }

    //create user api
    updateUserApi(postData){
      return this.http.post(`${this.BASE_URL}user/update`, postData )
      .catch(this.utilService.handleError);
    }

    updateStatusApi(id,status){
      return this.http.get(`${this.BASE_URL}user/status?userId=`+id + `&status=`+status)
      .catch(this.handleError);
    }

  get getToken(): string {
    // Check if current time is past access token's expiration
    const token = localStorage.getItem('token');
    return token ? token : null;
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  
  

  //function to handle errors
  private handleError(error: any) {
    if (error.status === 401) {
      return Observable.throw({
        error: 1,
        message: 'Unauthorized',
        responseObj: null
      });
    }
    else if (error.status === 404) {
      return Observable.throw({
        error: 1,
        message: 'Not found',
        responseObj: null
      });
    }

    else if (error.status === 500) {
      return Observable.throw(error.json());
    }
    else {
      return Observable.throw(error.json());
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.service.ts